import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Entities } from 'src/app/core/models/globals';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { HeaderService } from '../../../../core/services/header.service';

@Component({
  selector: 'app-application-main-panel',
  templateUrl: './application-main-panel.component.html',
  styleUrls: ['./application-main-panel.component.scss'],
})
export class ApplicationMainPanelComponent implements OnInit {

  lastRefreshedTime: Date;
  depName: string;
  cloudType: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navService: NavigationService,
    private headerService: HeaderService
  ) {}

  ngOnInit(): void {
    this.cloudType = this.route.snapshot.params['cloudType'] || this.route.parent.snapshot.params['cloudType']
    this.navService.sendCloud(this.cloudType)
    this.navService.subNavData(Entities.Applications);
    this.navService.breadcrumbDeployment.subscribe(x =>
      this.depName = x || this.route.snapshot.params['deploymentName'] || this.route.parent.snapshot.params['deploymentName']
    );
    this.navService.sendLastUpdate(this.headerService.getUserNewDate());
    this.navService.lastUpdateTime.subscribe((x) => {
      this.lastRefreshedTime = x;
    });
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }
}
